/* eslint new-cap: 0 */
import angulartics from 'angulartics';

export default angular.module('eventix.common.services.intercom',[angulartics])
    .provider('Intercom', function($analyticsProvider) {
        var user = null;

        this.load = function() {
            if (typeof window.Intercom === 'function') {
                window.Intercom('reattach_activator');
                window.Intercom('update', window.intercomSettings);
            } else {
                var _Intercom = function() {
                    _Intercom.push(arguments);
                };
                _Intercom.q = [];
                _Intercom.push = function(args) {
                    _Intercom.q.push(args);
                };
                window.Intercom = _Intercom;
                if(INTERCOM_ID && INTERCOM_ID.length) {
                    var s = document.createElement('script');
                    s.type = 'text/javascript';
                    s.async = true;
                    s.src = INTERCOM_URL;
                    var x = document.getElementsByTagName('script')[0];
                    x.parentNode.insertBefore(s, x);
                }
            }
        };

        $analyticsProvider.registerSetUsername(function(userId, properties = {}) {
            if(!window.Intercom) return;
            if(userId) {
                user = {
                    userId: userId,
                    properties: properties.user || properties
                };
                window.Intercom('boot', {
                    app_id: INTERCOM_ID,
                    user_id: userId,
                    email: _.get(properties, 'user.email'),
                    name: _.get(properties, 'user.name'),
                    company: {
                        company_id: _.get(properties, 'company.guid'),
                        name: _.get(properties, 'company.name'),
                    },
                    v3: true
                });
            } else {
                user = null;
                window.Intercom('shutdown');
            }
        });

        $analyticsProvider.registerPageTrack(_.throttle(() => {
            if(!user || !window.Intercom) return;
            window.Intercom('update');
        }, 10 * 1000));

        $analyticsProvider.registerEventTrack(function(eventName, properties = {}) {
            if(!user || !window.Intercom) return;
            window.Intercom('trackEvent', eventName, properties);
        });

        this.$get = angular.noop;
    }).name;
